<div class="wrap" [class.actionable]="isButton">
  <div class="left">
    <div
      [ngStyle]="color ? { color: 'var(--' + color + ')' } : {}"
      class="header"
    >
      {{ header }}
    </div>
    <div
      [ngStyle]="color ? { color: 'var(--' + color + ')' } : {}"
      *ngIf="text"
      class="text"
    >
      {{ text }}
    </div>
  </div>
  <div *ngIf="isButton" class="right">
    <app-svg-icon
      class="icon"
      [name]="'forward'"
      [color]="'color-neutral-6'"
    ></app-svg-icon>
  </div>
</div>
